<main class="mat-body">
    <div class="container progress-bar-wrapper">
        <div class="row">
            <div class="col-12">
                <thr-contract-progress-disinvestment [percent]="66"></thr-contract-progress-disinvestment>
            </div>
        </div>
    </div>

    <div class="container">
        <div class="row">
            <div class="col-12">
                <div class="row flex-nowrap justify-content-between align-items-end">
                    <div class="col-auto flex-shrink-1">
                        <h1 class="text-blue mat-display-1 mb-0" [innerHTML]="'disinvestment.detail'|translate"></h1>
                    </div>
                    <div class="col-auto">
                        <i class="icon-operative-natural text-blue"></i>
                    </div>
                </div>
                <hr class="mt-1 mb-3" />
                <h2 class="mat-subheading-1 text-blue font-weight-bold mb-3">{{ 'disinvestment.description'|translate }}</h2>
            </div>
        </div>
    </div>

    <form #formDisinvestment="ngForm" novalidate autocomplete="off" (submit)="onSubmit()" *ngIf="contract && contractData">
        <div class="bg-blue">
            <div class="container">
                <div class="row">
                    <div class="col-12 col-md-8 col-lg-6">
                        <mat-radio-group name="isTotal" [(ngModel)]="disinvestment.isTotal" [required]="true">
                            <div class="my-4">
                                <mat-radio-button class="d-block" name="total" color="blue-gray" [value]="true">
                                    {{ 'form.total'|translate }}
                                </mat-radio-button>
                            </div>

                            <div class="mb-4">
                                <mat-radio-button class="d-block" name="amount" color="blue-gray" [value]="false">
                                    {{ 'form.for-amount'|translate }}
                                </mat-radio-button>

                                <div class="ml-4 ml-sm-5" *ngIf="!disinvestment.isTotal">
                                    <mat-form-field class="full-width no-padding-bottom" [class.mat-form-field-invalid]="amountCtrl.invalid">
                                        <input type="hidden" name="amount" [min]="0.01" [max]="maximumInvestment" [(ngModel)]="disinvestment.amount" #amountCtrl="ngModel" />
                                        <input matInput #amountDirective="auto-numeric" thr-auto-numeric [placeholder]="'form.amount'|translate" required value="0" (keyup)="onAmountChange()" />
                                    </mat-form-field>
                                    <div>
                                        <mat-hint class="d-block mat-caption" *ngIf="amountCtrl.valid">
                                            {{ 'disinvestment.amount-tax'|translate }}
                                        </mat-hint>
                                        <mat-error class="d-block mat-caption" *ngIf="amountCtrl.hasError('max')
                                                   && !amountCtrl.hasError('required'); else amountRequired">
                                            <ng-container *ngIf="disinvestment.amount > contractData.balance; else minimumMaintain">
                                                {{ 'disinvestment.validation.maximum-amount'|translate }}
                                            </ng-container>
                                            <ng-template #minimumMaintain>
                                                {{ 'disinvestment.validation.minimum-to-maintain'|translate }}
                                            </ng-template>
                                        </mat-error>
                                        <ng-template #amountRequired>
                                            <mat-error class="d-block mat-caption" *ngIf="amountCtrl.invalid">
                                                {{ 'form.validation.required'|translate }}
                                            </mat-error>
                                        </ng-template>
                                    </div>
                                </div>
                            </div>
                        </mat-radio-group>
                    </div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <h2 class="mat-subheading-1 text-blue font-weight-bold my-3">{{ 'disinvestment.destiny-investment'|translate }}</h2>

                    <mat-radio-group name="cashRefund" [(ngModel)]="disinvestment.cashRefund" [required]="true">
                        <div class="row">
                            <div class="col-12 col-md-6 mb-4 order-0">
                                <mat-radio-button class="d-block" name="cash" color="blue-gray" [value]="true">
                                    {{ 'disinvestment.account'|translate }}: {{ contract.cashAccountIBAN }}
                                </mat-radio-button>
                            </div>
                            <div class="col-12 order-1 order-md-2" *ngIf="!disinvestment.isTotal && disinvestment.cashRefund">
                                <div class="row">
                                    <div class="col-12 col-md-8 col-lg-6">
                                        <mat-form-field class="full-width mb-3 mb-sm-4">
                                            <input name="doIban" matInput mask="SS00 0000 0000 00 0000000000" maxlength="35" iban [placeholder]="'disinvestment.iban'|translate" (ngModel)="contract.cashAccountIBAN" #ibanCtrl="ngModel" />
                                            <mat-error class="d-block mat-caption font-italic mt-2" *ngIf="ibanCtrl.hasError('iban')">
                                                {{ 'form.validation.iban'|translate }}
                                            </mat-error>
                                        </mat-form-field>
                                    </div>
                                </div>
                            </div>
                            <div class="col-12 col-md-6 mb-4 order-2 order-md-1">
                                <mat-radio-button class="d-block" name="transfer" color="blue-gray" [value]="false">
                                    {{ 'disinvestment.transfer'|translate }}: {{ contractData.model?.pivotFund.name }} ({{ contractData.model?.pivotFund.isin }})
                                </mat-radio-button>
                            </div>
                        </div>
                    </mat-radio-group>
                </div>

                <div class="col-12">
                    <div class="row flex-nowrap align-items-center mb-4">
                        <div class="col-auto pr-0">
                            <i class="icon-exclamation gray-icon-exclamation"></i>
                        </div>
                        <div class="col-auto flex-shrink-1 pl-2">
                            <p class="mat-caption text-error font-italic mb-0">{{ 'operative.refund-tax'|translate }}</p>
                        </div>
                    </div>
                </div>

                <div class="col-12 col-md-8 col-lg-6">
                    <mat-checkbox class="legal" name="legal" [(ngModel)]="disinvestment.disclaimer" required #legalCtrl="ngModel">
                        <a href="javascript:void(0)" (click)="showTerms()" [innerHTML]="'form.accept-disclaimer'|translate"></a>
                        <mat-error class="d-block" *ngIf="legalCtrl.invalid"> {{ 'form.validation.accept-legal'|translate }} </mat-error>
                    </mat-checkbox>
                </div>
            </div>

            <div class="row justify-content-end mb-5">
                <div class="col-12 col-sm-6 col-md-4">
                    <button type="submit" class="full-width mat-elevation-z0" mat-raised-button color="blue" [disabled]="!formDisinvestment.valid || !disinvestment.isComplete()">
                        {{ 'general.continue'|translate }}
                    </button>
                </div>
            </div>
        </div>
    </form>
</main>
